<div class="date">
  {{ clock$ | async | date : 'dd.MM.yyyy.' }}
</div>
<div class="clock">
  {{ clock$ | async | date: 'HH:mm' }}
</div>
<div class="info">
  <ng-content></ng-content>
</div>
